import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { ColectivoCorporativo } from '../../models/colectivo-corporativo/colectivo-corporativo.model';

@Injectable({
  providedIn: 'root',
})
export class CuentaColectivoCorporativoService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.CUENTA_COLECTIVO_CORPORATIVO}`;

  constructor(private http: HttpClient) {}

  getColectivos(): Observable<ColectivoCorporativo[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      map((items) =>
        (items || []).map((item) => ({
          codigo: String(item.codigo ?? ''),
          nit: String(item.nit ?? '').trim(),
          razonSocial: String(
            item.razon_social ?? item.razonSocial ?? ''
          ).trim(),
          tipoContrato: 'Colectivo Corporativo',
        }))
      )
    );
  }
}
